import { render, staticRenderFns } from "./GridVisitas.vue?vue&type=template&id=50e6744a&"
import script from "./GridVisitas.vue?vue&type=script&lang=js&"
export * from "./GridVisitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports